import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['radio']

  next() {
    const selected = this.radioTargets.find(r => r.checked)
    if (!selected) return

    const { url, message } = selected.dataset

    if (url) {
      window.location.assign(url)
      return
    }

    const $current = $(this.element.closest('.modal'))

    $current.one('hidden.bs.modal', () => (
      message ? flashAlert(message) : $(selected.value).modal('show')
    ))
    $current.modal('hide')
  }
}
